import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class T2LoadingService {

  private current = 0;
  private nameSource = new Subject<any>();
  name$ = this.nameSource.asObservable();

  private processSource = new Subject<any>();
  proccess$ = this.processSource.asObservable();

  constructor() { }


  show(proccess?: string) {
    this.current ++;
    this.processSource.next(proccess);
    this.nameSource.next(this.current);
  }

  hiden() {
    if (this.current > 0) {
      this.current --;
    }

    this.nameSource.next(this.current);
  }

}



// WEBPACK FOOTER //
// ./src/app/trip2-theme/components/t2-loading/t2-loading.service.ts